import {
  CART_CHECKOUT_BASE_URL,
  CART_PATH,
  CHECKOUT_PATH,
  REGISTER_REDIRECT_PATH,
  SITE_ID_URL_PARAM_KEY,
} from '@config/constants';
import { SiteId } from 'wly-ecommerce-common';
import { SiteConfig } from './SiteConfig';
import { getCartCookies } from './cookie';

export const buildRedirectUrl = (
  redirectDomain: string,
  redirectPath: string,
  queryParams?: Record<string, string>,
): string => {
  const {
    locale, siteId, hostUrl, isWileyComHosted,
  } = SiteConfig.getConfig();
  let urlLocaleStr = '';
  let baseUrl = hostUrl;

  if (isWileyComHosted || redirectPath === REGISTER_REDIRECT_PATH) {
    urlLocaleStr = `/${locale}`;
  }

  if (isWileyComHosted) {
    baseUrl = redirectDomain;
  }

  let redirectUrl = `${baseUrl}${urlLocaleStr}${redirectPath}`;
  const params = new URLSearchParams();

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => params.set(key, value));
  }

  if ([SiteId.COD, SiteId.WILA, SiteId.AUTHOR].includes(siteId)) {
    params.set(SITE_ID_URL_PARAM_KEY, siteId);
  }

  if (params.toString()) {
    redirectUrl += `?${params.toString()}`;
  }

  return redirectUrl;
};

export const buildProceedToCheckoutRedirectUrl = () => {
  const { ecomToken } = getCartCookies();
  const { isWila } = SiteConfig.getConfig();
  const isAuth = Boolean(ecomToken);

  let redirectUrl = window.location.href.replace(CART_PATH, CHECKOUT_PATH);
  if (!isAuth) {
    let target = window.location.href;

    if (isWila) {
      target = buildRedirectUrl(CART_CHECKOUT_BASE_URL, CHECKOUT_PATH);
    }

    redirectUrl = buildRedirectUrl(
      CART_CHECKOUT_BASE_URL,
      REGISTER_REDIRECT_PATH,
      { target },
    );
  }

  return redirectUrl;
};
